module.exports = __webpack_public_path__ + "img/list_baohe.5ce0270b.png";